module.exports = __webpack_public_path__ + "img/logo_recruitment-Accelerator-big.69a7ec58.png";